import { useMemo } from 'react';

import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { Bets } from '../../../config/bets';
import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';

import { useIsBetConfirmedConnected } from './useIsBetConfirmedConnected';

export const useIsAutoCashoutDisabled = (betCode: Bets): boolean => {
  const currentStatus = useGameStateSlice.getCurrentStatus();
  const isBetConfirmned = useIsBetConfirmedConnected(betCode);
  const betLimits = useBetSlice.betLimits() ?? {};
  const betMinLimit = betLimits[betCode].min;
  const remainingBalance = useHighflyerStateSlice.balance();
  const isDealingIngProgress = useHighflyerStateSlice.isDealingInProgress(betCode);
  const hasEarlyBets = useHighflyerStateSlice.hasEarlyBets(betCode);

  return useMemo(() => {
    let isDisabled = false;
    const isLowBalance = remainingBalance < betMinLimit;
    if (isBetConfirmned) {
      isDisabled = true;
    }
    if (
      [GameStatus.Dealing, GameStatus.WaitForNextGame, GameStatus.Result].includes(currentStatus as GameStatus) &&
      !isDealingIngProgress
    ) {
      isDisabled = false;
    }
    if (hasEarlyBets) {
      isDisabled = true;
    }
    if (isLowBalance) {
      isDisabled = true;
    }
    return isDisabled;
  }, [currentStatus, isBetConfirmned, betMinLimit, remainingBalance, isDealingIngProgress, hasEarlyBets]);
};
